$(function () {
  $('dl.help dt.btn-link').on('click', function () {
    var collapseDownIcon = $(this).children('i.fa-caret-down');
    var collapseUpIcon = $(this).children('i.fa-caret-up');

    if (collapseDownIcon.length > 0) {
      collapseDownIcon.addClass('fa-caret-up');
      collapseDownIcon.removeClass('fa-caret-down');
    } else {
      collapseUpIcon.addClass('fa-caret-down');
      collapseUpIcon.removeClass('fa-caret-up');
    }

  });
});